import { ReactNode, useRef } from 'react';
import { useSidebarContext } from '../context';
import { PopupMenuType } from './types';
import sendMenuClickEvent from '~/utils/analytics/sendMenuClickEvent';

export interface PopupMenuTriggerProps {
  name: PopupMenuType;
  children: ReactNode;
}

export default function PopupMenuTrigger({ name, children }: PopupMenuTriggerProps) {
  const triggerRef = useRef(null);
  const { openPopupMenu } = useSidebarContext();

  return (
    <button
      className="legacy-dropdown-menu-toggle"
      ref={triggerRef}
      onClick={() => {
        openPopupMenu(name, triggerRef);
        sendMenuClickEvent(name);
      }}
    >
      {children}
    </button>
  );
}